import Modal from 'react-modal';

// material ui
import { Box, Button, Divider, FormControl, Grid, Input, InputAdornment, InputLabel, Stack, Typography } from '@mui/material';

import { yupResolver } from '@hookform/resolvers/yup';

import { useForm } from 'react-hook-form';
import * as yup from 'yup';

// graphql
import { AddCoordinatorPaymentInput, useAddCoordinatorPaymentMutation } from '@/generated/graphql';

import { IAddCoordinatorPaymentInput } from 'src/shared/interfaces';

interface Props {
  refetchData: () => void;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  coordinatorId: string | undefined;
}

export const AddPayment = ({ refetchData, open, setOpen, coordinatorId }: Props) => {
  const handleClose = () => setOpen(false);

  const schema = yup
    .object({
      payment: yup.number().required(),
    })
    .required();

  const {
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IAddCoordinatorPaymentInput>({
    resolver: yupResolver(schema),
  });

  const [addCoordinatorPaymentMutation] = useAddCoordinatorPaymentMutation();

  const onSubmit = async (dataInput: IAddCoordinatorPaymentInput) => {
    const { payment } = dataInput;

    if (coordinatorId) {
      const input: AddCoordinatorPaymentInput = {
        coordinatorId: coordinatorId,
        payment: parseFloat(payment),
      };

      const { data } = await addCoordinatorPaymentMutation({
        variables: {
          input,
        },
      });

      if (data) console.log(data);
      if (errors) console.log(errors);
      refetchData();
      handleClose();
      reset();
    }
  };

  const handlePaymentAmountInput = (value: string) => {
    if (value) {
      reset({
        payment: value,
      });
    } else {
      reset({
        payment: '',
      });
    }
  };

  return (
    <>
      <Modal
        isOpen={open}
        onRequestClose={handleClose}
        style={{
          overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            color: 'inherit',
            backgroundColor: 'rgba(25, 25, 25, 0.75)',
          },
          content: {
            width: '340px',
            overflow: 'unset',
            position: 'absolute',
            margin: '0.1% auto',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            padding: 0,
            marginRight: '-50%',
            transform: 'translate(-50%, -48vh)',
            border: '0px',
            background: 'transparent',
            WebkitOverflowScrolling: 'touch',
            borderRadius: '4px',
            outline: 'none',
          },
        }}>
        <Box
          sx={{
            backgroundColor: '#fff',
            overflow: 'unset',
            borderRadius: '5px',
          }}
          mt={9}>
          <Box sx={{ px: 5, py: 2 }} alignItems={'center'}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography gutterBottom variant="subtitle2" m={0}>
                Add operator payment
              </Typography>
            </Stack>
          </Box>
          <Divider />

          <Box px={5} pt={2} pb={2}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid>
                <FormControl fullWidth sx={{ mt: 5 }} variant="standard">
                  <InputLabel htmlFor="standard-adornment-amount">Payment</InputLabel>
                  <Input
                    id="standard-adornment-amount"
                    {...register('payment')}
                    onChange={(text) => handlePaymentAmountInput(text.currentTarget.value.replace(/[^0-9.]/g, ''))}
                    startAdornment={<InputAdornment position="start">₱</InputAdornment>}
                  />
                </FormControl>
              </Grid>
              <Grid container justifyContent={'end'} mt={5}>
                <Button
                  type="submit"
                  size="small"
                  variant="contained"
                  sx={{
                    background: 'grey',
                    fontSize: 10,
                    fontWeight: 600,
                    paddingLeft: '20px',
                    paddingRight: '20px',
                    textTransform: 'unset',
                  }}
                  onClick={handleClose}>
                  Cancel
                </Button>
                <Button
                  sx={{
                    ml: 1,
                    fontSize: 10,
                    fontWeight: 600,
                    paddingLeft: '20px',
                    paddingRight: '20px',
                    paddingTop: '8px',
                    paddingBottom: '8px',
                    textTransform: 'unset',
                  }}
                  type="submit"
                  size="small"
                  variant="contained">
                  Submit
                </Button>
              </Grid>
            </form>
          </Box>
        </Box>
      </Modal>
    </>
  );
};
